<!-- backend/src/components/Cards/CardGostergelerSettings.svelte -->


<script>
  import { onMount } from 'svelte';
  import { boyutList, gostergeAdd, gostergeUpdate } from '../../Api.svelte';
  import { gostergelerStore, selectedGosterge, isGostergeEditing } from "../../stores/stores";

  let name = '';
  let tanim = '';
  let kaynak = '';
  let deger_sayisi = '';
  let _id = null;
  let gostergeEditing = false;
  let boyutlar = [];
  let selectedBoyut = '';

  // Göstergeleri almak ve düzenleme moduna geçmek
  selectedGosterge.subscribe(gosterge => {
    if (gosterge) {
      _id = gosterge._id;
      selectedBoyut = gosterge.boyut_id;
      name = gosterge.name;
      tanim = gosterge.tanim;
      kaynak = gosterge.kaynak;
      deger_sayisi = gosterge.deger_sayisi;
    }
  });

  // Düzenleme modunu kontrol etmek
  isGostergeEditing.subscribe(editing => {
    gostergeEditing = editing;
  });

  // Boyutları almak
  onMount(async () => {
    boyutlar = await boyutList();
  });

  async function submitForm() {
    try {
      if (gostergeEditing) {
        await updateGosterge();
      } else {
        await addGosterge();
      }
    } catch (error) {
      console.error('Form gönderme hatası:', error);
    }
  }

  async function addGosterge() {
    try {
      const result = await gostergeAdd(selectedBoyut, name, tanim, kaynak, deger_sayisi);
      if (result) {
        gostergelerStore.set(result);
        resetForm();
      } else {
        console.error('Gösterge ekleme başarısız.');
      }
    } catch (error) {
      console.error('Gösterge ekleme hatası:', error);
    }
  }

  async function updateGosterge() {
    try {
      const result = await gostergeUpdate(_id, selectedBoyut, name, tanim, kaynak, deger_sayisi);
      if (result) {
        gostergelerStore.set(result);
        resetForm();
      } else {
        console.error('Gösterge güncelleme başarısız.');
      }
    } catch (error) {
      console.error('Gösterge güncelleme hatası:', error);
    }
  }

  function resetForm() {
    _id = null;
    selectedBoyut = '';
    name = '';
    tanim = '';
    kaynak = '';
    deger_sayisi = '';
    isGostergeEditing.set(false);
    selectedGosterge.set(null);
  }
</script>

<div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
  <div class="rounded-t mb-0 px-4 py-3 border-0">
    <div class="flex flex-wrap items-center">
      <div class="relative w-full px-4 max-w-full flex-grow flex-1">
        <h3 class="font-semibold text-lg text-blueGray-700">
          {gostergeEditing ? 'Göstergeyi Düzenle' : 'Gösterge Ekle'}
        </h3>
      </div>
    </div>
  </div>
  <div class="block w-full overflow-x-auto">
    <form on:submit|preventDefault={submitForm}>
      <div class="px-6 py-4">
        <div class="flex flex-wrap -mx-4">
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-password">
                Boyut
              </label>
              <div class="relative">
                <select class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline" bind:value={selectedBoyut} required>
                  <option value="" disabled selected hidden>Seçiniz</option>
                  {#each boyutlar as boyut}
                  <option value={boyut._id}>{boyut.name}</option>
                  {/each}
                </select>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-password">
                Adı
              </label>
              <input type="text" class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full" bind:value={name} required />
            </div>
          </div>
          <div class="w-full lg:w-12/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-password">
                Tanım
              </label>
              <textarea class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full" bind:value={tanim} rows="4" required></textarea>
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-password">
                Kaynak
              </label>
              <input type="text" class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full" bind:value={kaynak} required />
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-password">
                Değişken Sayısı
              </label>
              <input type="number" class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full" bind:value={deger_sayisi} required />
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end">
          <button class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150" type="button" on:click={resetForm}>
            {gostergeEditing ? 'İptal' : 'Temizle'}
          </button>
          <button class="bg-emerald-500 text-white active:bg-blueGray-400 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150" type="submit">
            {gostergeEditing ? 'Güncelle' : 'Ekle'}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
